import { apiAddLineItem, apiDeleteLineItem, apiGetUserCart, apiUpdateCartItemsProperties } from "Root/api/apiProfile";
import { hasAttributeError, prepareUpdateItemBody, validateAddItemBody, validateFlavorsQuantity, } from "Root/profile/components/SubscriptionPageV2/utils";
import toastService from "Root/profile/toastService";
import utils, { uuid } from "Root/profile/utils";
import { setGlobalLoading, setOriginalUserCart, setUserCart } from "../../actionCreators/makeActionCreator";
import { LoadPricingThunk } from "../orders/pricing";
import LoadMissingAddonsThunk from "./missingAddons";
import { capitalize } from "Root/profile/utils";
import { LoadOrderStatusDataThunk } from "../orders/orderDetails";
export const LoadUserCartThunk = () => async (dispatch) => {
    try {
        const result = await apiGetUserCart();
        const mapCartItem = (cartItem) => cartItem.bags_info
            ? cartItem.bags_info.map((bag) => {
                if (cartItem.item_type === "hydration" ||
                    cartItem.item_type === "preworkout" ||
                    cartItem.item_type === "greens") {
                    const arr = new Array(bag.quantity)
                        .fill({
                        id: uuid(),
                        applyAll: false,
                        selected_flavors: cartItem.available_flavors.map((flavor) => {
                            const selectedFlavor = bag.selected_flavors.find((selected_flavor) => flavor.short_name === selected_flavor.short_name);
                            if (selectedFlavor) {
                                return {
                                    ...selectedFlavor,
                                };
                            }
                            return {
                                short_name: flavor.short_name,
                                count: 0,
                            };
                        }),
                        attributes: bag.attributes,
                        quantity: bag.quantity,
                        sku: bag.sku,
                    })
                        .map((c) => ({ ...c, id: uuid() }));
                    return arr;
                }
                if (cartItem.item_type === "protein") {
                    const arr = [
                        {
                            id: uuid(),
                            applyAll: false,
                            selected_flavors: cartItem.available_flavors.map((flavor) => {
                                const selectedFlavor = bag.selected_flavors.find((selected_flavor) => flavor.short_name === selected_flavor.short_name);
                                if (selectedFlavor) {
                                    return {
                                        ...selectedFlavor,
                                    };
                                }
                                return {
                                    short_name: flavor.short_name,
                                    count: 0,
                                };
                            }),
                            attributes: bag.attributes,
                            quantity: bag.quantity,
                            sku: bag.sku,
                        },
                    ].map((c) => ({ ...c, id: uuid() }));
                    return arr;
                }
                return bag;
            })
            : [cartItem];
        const userCart = result.map((cartItem) => ({
            ...cartItem,
            bags_info: mapCartItem(cartItem).flat(),
        }));
        const originalUserCart = JSON.parse(JSON.stringify(userCart));
        dispatch(setUserCart(userCart));
        dispatch(setOriginalUserCart(originalUserCart));
    }
    catch (e) {
        toastService.errorMessage("Something went wrong");
    }
};
export const DeleteUserCartItemThunk = (deleteBody) => async (dispatch, getState) => {
    if (getState().userCart.length === 1) {
        toastService.errorMessage("Must have at least 1 subscription item in your cart");
        return;
    }
    try {
        const body = getState().userCart.find((item) => item.sku === deleteBody.item_key);
        dispatch(setGlobalLoading(true));
        await apiDeleteLineItem({
            item_key: body?.skus_list || [deleteBody.item_key],
            next_order_only: deleteBody.next_order_only,
        });
        const deletedItem = getState().userCart.find((item) => item.sku === deleteBody.item_key);
        await dispatch(LoadUserCartThunk());
        await dispatch(LoadMissingAddonsThunk());
        await dispatch(LoadPricingThunk());
        await dispatch(LoadOrderStatusDataThunk());
        toastService.successMessage(`${deletedItem?.title} removed from your subscription`);
    }
    catch (e) {
        toastService.errorMessage(e.message.message);
    }
    finally {
        dispatch(setGlobalLoading(false));
    }
};
export const AddUserCartItemThunk = (body, selectedProteinFlavors) => async (dispatch, getState) => {
    try {
        if (selectedProteinFlavors && utils.isFlavorBoost(body)) {
            const requestBody = [
                {
                    item: body,
                    attributes: {},
                    flavors: selectedProteinFlavors
                        .filter((flavor) => !!flavor.count)
                        .map((flavor) => ({ short_name: flavor.short_name, count: flavor.count })),
                    quantity: 1,
                },
            ];
            dispatch(setGlobalLoading(true));
            await apiAddLineItem(undefined, requestBody);
            await dispatch(LoadUserCartThunk());
            await dispatch(LoadMissingAddonsThunk());
            await dispatch(LoadPricingThunk());
            await dispatch(LoadOrderStatusDataThunk());
            toastService.successMessage(`Flavor boost was added`);
            return;
        }
        const item = getState().missingAddons.find((addon) => addon.product_key === body);
        if (item) {
            const requestBody = item.bags_info
                ? item.bags_info.map((bag) => ({
                    id: bag.id,
                    item: item.product_key,
                    attributes: bag.attributes.reduce((prev, curr) => ({
                        ...prev,
                        [curr.attribute_name]: curr.attribute_on,
                        sweat_level: null,
                        flavor: bag.selected_flavors.find((flavor) => flavor.count)?.short_name,
                    }), {}),
                    flavors: bag.selected_flavors
                        .filter((flavor) => !!flavor.count)
                        .map((flavor) => {
                        if (flavor.count > 1) {
                            const arr = new Array(flavor.count).fill({
                                short_name: flavor.short_name,
                            });
                            return arr;
                        }
                        return [
                            {
                                short_name: flavor.short_name,
                            },
                        ];
                    })
                        .flat(),
                    quantity: item.product_key === "preworkout" || item.product_key === "hydration" || item.product_key === "greens"
                        ? 1
                        : Number(item.quantity),
                }))
                : [
                    {
                        item: item.product_key,
                        attributes: {},
                        flavors: [],
                        quantity: item.quantity,
                    },
                ];
            const isValid = requestBody
                .map((reqBodyItem) => validateAddItemBody(reqBodyItem))
                .every((reqBodyItem) => !!reqBodyItem);
            if (isValid) {
                dispatch(setGlobalLoading(true));
                await apiAddLineItem(undefined, requestBody);
                await dispatch(LoadUserCartThunk());
                await dispatch(LoadMissingAddonsThunk());
                await dispatch(LoadPricingThunk());
                await dispatch(LoadOrderStatusDataThunk());
                toastService.successMessage(`${item.title} added`);
            }
        }
    }
    catch (e) {
        toastService.errorMessage("Something went wrong");
        if (hasAttributeError(e)) {
            await dispatch(LoadUserCartThunk());
            await dispatch(LoadMissingAddonsThunk());
            await dispatch(LoadPricingThunk());
        }
    }
    finally {
        dispatch(setGlobalLoading(false));
    }
};
export const updateItemsThunk = (nextOrder) => async (dispatch, getState) => {
    const reduxUserCart = getState().userCart;
    const { originalUserCart } = getState();
    const isValid = validateFlavorsQuantity(reduxUserCart, originalUserCart);
    if (isValid) {
        try {
            dispatch(setGlobalLoading(true));
            await apiUpdateCartItemsProperties({ ...prepareUpdateItemBody(reduxUserCart), next_order_only: !!nextOrder });
            await dispatch(LoadUserCartThunk());
            await dispatch(LoadMissingAddonsThunk());
            await dispatch(LoadPricingThunk());
            await dispatch(LoadOrderStatusDataThunk());
            toastService.successMessage("Your items were successfully updated");
        }
        catch (e) {
            toastService.errorMessage(e);
        }
        finally {
            dispatch(setGlobalLoading(false));
        }
    }
};
export const addNotRecommendedItem = (body) => async (dispatch) => {
    try {
        dispatch(setGlobalLoading(true));
        await apiAddLineItem(undefined, [body]);
        await dispatch(LoadUserCartThunk());
        await dispatch(LoadMissingAddonsThunk());
        await dispatch(LoadPricingThunk());
        await dispatch(LoadOrderStatusDataThunk());
        toastService.successMessage(`${capitalize(body.item)} was added.`);
    }
    catch (e) {
        toastService.errorMessage("Could not add not recommended product.");
    }
    finally {
        dispatch(setGlobalLoading(false));
    }
};
